import { resolveSalesStatusCategory } from '@/composables/shared/useSalesStatus';

export const resolveSaleStatusCategory = (row) => resolveSalesStatusCategory(row);

export const countRowsByStatus = (rows, statusKey) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  return safeRows.filter((row) => resolveSaleStatusCategory(row) === statusKey).length;
};

export const buildSalesStatusTabs = (rows) => {
  const safeRows = Array.isArray(rows) ? rows : [];

  return [
    { key: 'all', label: 'Todos', count: safeRows.length, showCount: true },
    { key: 'open', label: 'Abiertos', count: countRowsByStatus(safeRows, 'open'), showCount: true },
    { key: 'closed', label: 'Cerrados', count: countRowsByStatus(safeRows, 'closed'), showCount: true },
    { key: 'canceled', label: 'Cancelados', count: countRowsByStatus(safeRows, 'canceled'), showCount: true },
  ];
};

export const filterRowsByStatus = (rows, activeStatusTab) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  if (activeStatusTab === 'all') {
    return safeRows;
  }

  return safeRows.filter((row) => resolveSaleStatusCategory(row) === activeStatusTab);
};

export const resolveSaleName = (row) => {
  return String(row?.sale_name || row?.project || row?.name || row?.code || '').trim() || '-';
};
